import { HttpClient } from "./http/signup-http-client";
export const SIGNUP_URL = '/signup.cgi';
export const SignupService = {

    initialLoad: () => {
        return HttpClient.get(SIGNUP_URL, {
            action: 'init',
        })
    },
    clientIdValidation: (client_id) => {
        return HttpClient.post(SIGNUP_URL, {
            action: 'client_id_validation',
            client_id: client_id
        })
    },
    clientEmailValidation: (email) => {
        return HttpClient.post(SIGNUP_URL, {
            action: 'client_email_validation',
            email: email
        })
    },
    createClient: (payload) => {
        return HttpClient.postJSONasFormData(SIGNUP_URL, {
            action: 'create_client',
            ...payload
        })
    },
    countriesByCity: (payload) => {
        return HttpClient.post(SIGNUP_URL, {
            action: 'countries_by_city',
            city:payload
        })
    },
    isValidVatId: (payload) => {
        return HttpClient.post(SIGNUP_URL, {
            action: 'is_valid_vat_id',
            ...payload
        })
    },
    isEuCountry: (payload) => {
        return HttpClient.post(SIGNUP_URL, {
            action: 'check_eu_country',
            country:payload
        })
    },
    getPaymentFormData: (payload) => {
        return HttpClient.post(SIGNUP_URL, {
            action: 'get_payment_form_data',
            ...payload
        })
    },


  
}

